export default {"src":"/_next/static/media/early-access.1790405d.svg","height":19,"width":124,"blurWidth":0,"blurHeight":0};